<template>
  <Page>
    <SidePageColumn side="left">
      <v-divider class="mt-4" v-if="attrs.quick_links.length > 0"></v-divider>
      <QuickSideLinks
        :quick_links="attrs.quick_links"
        v-if="attrs.quick_links.length > 0"
      ></QuickSideLinks>
      <v-list shaped dense max-width="98.5%" class="grey lighten-5">
        <v-subheader class="pl-5">Panel Managment Menu</v-subheader>
        <v-list-item-group color="primary" class="pl-3">
          <SideMenuItem
            v-for="(menu_item, index) in owner_menu_objects"
            :key="index"
            :to="menu_item.to"
            :icon="menu_item.icon"
            :label="menu_item.label"
            :badge_value="menu_item.badge_value ? menu_item.badge_value : 0"
          ></SideMenuItem>
        </v-list-item-group>
      </v-list>
    </SidePageColumn>
    <CenterPageColumn :has_nav_bar="true">
      <router-view
        :user="user"
        :is_loading="is_loading"
        @on-show-loader="$emit('on-show-loader')"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-login-modal="on_show_login_modal"
        @set-master-page-attrs="on_set_master_page_attrs"
        @set-missing-badge-count="on_set_missing_badge_count"
      ></router-view>
      <Footer
        :is_loading="is_loading"
        @on-hide-loader="$emit('on-hide-loader')"
        @on-show-loader="$emit('on-show-loader')"
      ></Footer>
    </CenterPageColumn>
  </Page>
</template>
<script>
import Page from "./../../components/Page";
import SidePageColumn from "./../../components/SidePageColumn";
import QuickSideLinks from "./../../components/QuickSideLinks";
import NavbarMenuItem from "../../components/NavbarMenuItem";
import SideMenuItem from "../../components/SideMenuItem";
import ServerClient from "../../lib/ServerClient";
import Utils from "../../lib/Utils";
import CenterPageColumn from "./../../components/CenterPageColumn";
import Footer from "./../../components/CenterFooter";
export default {
  name: "Owner",
  components: {
    Page,
    NavbarMenuItem,
    SideMenuItem,
    SidePageColumn,
    CenterPageColumn,
    Footer,
    QuickSideLinks,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      owner_menu_objects: [
        {
          label: "Dashboard",
          icon: "mdi-home-city-outline",
          to: "/owner/dashboard",
          roles: ["owner"],
        },
        {
          label: "Promotions",
          icon: "mdi-home-city-outline",
          to: "/owner/promotions",
          roles: ["owner"],
        },
        {
          label: "Messages",
          icon: "mdi-home-city-outline",
          to: "/owner/contact_us_messages",
          roles: ["owner"],
        },
        {
          label: "Businesses",
          icon: "mdi-home-city-outline",
          to: "/owner/businesses",
          roles: ["owner"],
        },
        {
          ky: "missing_info",
          badge_value: 0,
          label: "Missing Info",
          icon: "mdi-home-city-outline",
          to: "/owner/missing",
          roles: ["owner"],
        },
        {
          label: "Reports",
          icon: "mdi-home-city-outline",
          to: "/owner/reports",
          roles: ["owner"],
        },
        {
          label: "Notifications",
          icon: "mdi-home-city-outline",
          to: "/owner/notifications",
          roles: ["owner"],
        },
        {
          label: "Security",
          icon: "mdi-home-city-outline",
          to: "/owner/security",
          roles: ["owner"],
        },
      ],
      user: null, //digitalocean@2015
      attrs: Utils.get_default_master_page_attr(),
    };
  },
  methods: {
    can_access(menu_item) {
      var res = Utils.can_access(this.user, menu_item);
      return res;
    },
    on_show_login_modal(config) {
      this.$emit("on-show-login-modal", config);
    },
    on_set_master_page_attrs(attrs) {},
    on_set_missing_badge_count(val) {
      var temp = [];
      //set the count to the menu items
      for (let index = 0; index < this.owner_menu_objects.length; index++) {
        var mo = this.owner_menu_objects[index];
        if (mo.ky && mo.ky == "missing_info") {
          mo.badge_value = val;
        }
        temp.push(mo);
      }
      this.owner_menu_objects = temp;
    },
    load_missing_info_badge_value() {
      ServerClient.Businesses.get_my_missing_info_report(
        {
          user_id: this.user.id,
        },
        (res) => {
          //console.log("res: ", res);
          var items = Utils.scan_businesses_missing_info(
            res.businesses,
            res.hollidays
          );
          this.on_set_missing_badge_count(items.length);
        },
        (errors) => {
          console.log(
            "Errors while loading badge value for missing info on owners master page",
            errors
          );
        }
      );
    },
  },
  mounted() {
    this.user = ServerClient.Login.get_logged_in_user();
    // console.log("the user", this.user);
    this.load_missing_info_badge_value();
    if (this.$route.path == "/owner" || this.$route.path == "/owner/" ) {
      //redirect to dashboard
      this.$router.push("/owner/dashboard");
    }
  },

};
</script>